/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import { toast } from "react-toastify";
import { axiosSA } from "../../axios";
import * as actionTypes from "./actionTypes";
import {
  processAllProperties,
  processSelectedDateProperties,
} from "../../shared/geofence";
import moment from "moment";
import { constant } from "./../../shared/constants/constants";
import { startLoading, stopLoading } from "./index";
import { setToken } from "./index";
import {
  convertPropertiesV1toV0,
  convertRequestBodyOfPropertyV0toV1,
} from "../../shared/helper";

// fetch geofences
export const fetchGeofence = () => {
  return (dispatch, getState) => {
    let params = new URLSearchParams(window.location.search);
    let propertyId = params.get("propertyId");

    // if propertyId is present in Url query params fetch a single property/geofence first
    if (propertyId) dispatch(fetchAProperty(propertyId));
    // if propertyId is not present in Url query params fetch all property/geofence
    else dispatch(fetchAllProperty(null, null, { currentPage: 1 }));
  };
};

// fetch single property/geofence
const fetchAProperty = (propertyId) => {
  return async (dispatch, getState) => {
    let token = await dispatch(setToken());
    axiosSA
      .get(`/properties/list`, {
        params: {
          id: propertyId,
          allowInactive: true,
          isFetchGeometries: true
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        // if geofence is not present show toast else store that in state
        if (res.data.data.length === 0) {
          toast.info(constant.REQUIRED_PROPERTY_NOT_FOUND);
        } else {
          dispatch(
            setGeofence(
              processAllProperties(convertPropertiesV1toV0(res.data.data))
            )
          );
        }
        // fetch all property/geofence
        dispatch(fetchAllProperty(null, null, { currentPage: 1 }));
      })
      .catch((err) => {
        // fetch all property/geofence even if some error occurred
        dispatch(fetchAllProperty(null, null, { currentPage: 1 }));
        toast.error(constant.UNABLE_TO_GET_REQUIRED_PROPERTY);
              });
  };
};

// fetch all property/geofence
export const fetchAllProperty = (allowInactive, workOrderDate, page) => {
  return (dispatch, getState) => {
    let date = workOrderDate;
    if (date) date = moment(date).format("YYYYMMDD");
    else date = null;
    // if different date is selected clear already present properties/geofences
    if (allowInactive === true || allowInactive === false || date) {
      dispatch(clearGeofence());
    }
    dispatch(startLoading());
    dispatch(fetchAllPropertyHelper(allowInactive, date, page));
  };
};

// fetch all property/geofence helper method
const fetchAllPropertyHelper = (allowInactive, workOrderDate, page) => {
  return async (dispatch, getState) => {
    let token = await dispatch(setToken());
    axiosSA
      .get(`/properties/list`, {
        params: {
          pageSize: 200,
          pageNo: page.currentPage,
          allowInactive: allowInactive ? true : false,
          workOrderDate: workOrderDate,
          isFetchGeometries: true
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        // if no property is present show toast
        if (res.data.data.length < 1) {
          toast.info(constant.NO_PROPERTIES_FOUND);
          dispatch(stopLoading());
          return;
        }
        let lastPage = res.data.meta.page.lastPage;

        // if date is present process data accordingly and set in state
        if (workOrderDate) {
          dispatch(
            setGeofence(
              processSelectedDateProperties(
                convertPropertiesV1toV0(res.data.data)
              )
            )
          );
        } else {
          dispatch(
            setGeofence(
              processAllProperties(
                convertPropertiesV1toV0(res.data.data),
                getState().geofence.geofenceData[0]
              )
            )
          );
        }

        // increment page count
        page.currentPage++;

        // if fetched pages count is greater than last page show toast and return
        if (page.currentPage > lastPage) {
          toast.info(
            `${constant.TOTAL_NO_OF_PROPERTIES} : ${
              getState().geofence.geofenceData.length
            }`
          );
          dispatch(stopLoading());
          return;
        }
        // recursively call method with incremented current page count
        dispatch(fetchAllPropertyHelper(allowInactive, workOrderDate, page));
      })
      .catch((err) => {
        dispatch(stopLoading());
        toast.error(constant.SOME_ERROR_OCCURRED_IN_FETCHING_PROPERTIES);
              });
  };
};

// save newly created or updated geofences
export const saveGeofenceGeometries = (propertyId, postData) => {
  return async (dispatch, getState) => {
    let token = await dispatch(setToken());
        const convertedPostData = convertRequestBodyOfPropertyV0toV1(postData);
    toast.info(constant.SAVING_GEOMETRIES, { autoClose: false, toastId: 10 });
    axiosSA
      .post(`/properties/${propertyId}`, convertedPostData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        toast.dismiss(10);
        toast.success(constant.SUCCESSFULLY_SAVED_GEOMETRIES);
      })
      .catch((err) => {
        toast.dismiss(10);
        toast.error(constant.SOME_ERROR_OCCURRED_IN_SAVING_GEOMETRIES);
      });
  };
};

// update property/geofence
export const updatePropertyStoreData = (data) => {
  return {
    type: actionTypes.UPDATE_PROPERTIES,
    data,
  };
};

// set property/geofence
const setGeofence = (data) => {
  return {
    type: actionTypes.SET_GEOFENCE,
    data,
  };
};

// clear property/geofence
const clearGeofence = (data) => {
  return {
    type: actionTypes.CLEAR_GEOFENCE,
  };
};
